module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "toolbar-container"
  }, [_c('toolbar')], 1), _vm._v(" "), _c('div', {
    staticClass: "template-container"
  }, [_c('page'), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right btn"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scene-container"
  }, [_c('scene')], 1), _vm._v(" "), _c('div', {
    staticClass: "action-timeline-container"
  }, [_c('action-timeline')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-container"
  }, [_c('panel-right')], 1), _vm._v(" "), _c('div', {
    staticClass: "editor-timeline-container"
  }, [_c('editor-timeline')], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "收藏提示",
      "size": "tiny",
      "visible": _vm.dialog_collect_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_collect_visible = $event
      }
    },
    model: {
      value: (_vm.dialog_collect_visible),
      callback: function($$v) {
        _vm.dialog_collect_visible = $$v
      },
      expression: "dialog_collect_visible"
    }
  }, [_c('span', [_vm._v("确认是否收藏该素材？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog_collect_visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCollect
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消收藏提示",
      "size": "tiny",
      "visible": _vm.dialog_cancel_collect_visible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_cancel_collect_visible = $event
      }
    },
    model: {
      value: (_vm.dialog_cancel_collect_visible),
      callback: function($$v) {
        _vm.dialog_cancel_collect_visible = $$v
      },
      expression: "dialog_cancel_collect_visible"
    }
  }, [_c('span', [_vm._v("确认是否取消收藏该素材？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog_cancel_collect_visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleCancelCollect
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20814346","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/Ui.vue
// module id = 376
// module chunks = 0